/*=============================================== Video ===============================================*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
var Vid = React.lazy(function () { return import("./Vid"); });
/*==================== Component ====================*/
var Video = function (_a) {
    var width = _a.width, height = _a.height, fit = _a.fit, aspectRatio = _a.aspectRatio, _b = _a.emptyText, emptyText = _b === void 0 ? "Your browser doesn't support the video tag." : _b, autoPlay = _a.autoPlay, muted = _a.muted, src = _a.src, controls = _a.controls, props = __rest(_a, ["width", "height", "fit", "aspectRatio", "emptyText", "autoPlay", "muted", "src", "controls"]);
    return (React.createElement(Vid, __assign({ "$width": width, "$height": height, "$fit": fit, "$aspectRatio": aspectRatio, autoPlay: autoPlay, muted: autoPlay ? true : autoPlay, controls: !autoPlay ? true : controls }, props),
        React.createElement("source", { src: src, type: "video/mp4" }),
        emptyText));
};
export default Video;
